export enum LogoutEvent {
    ClearNotifications
}